import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';

type EditIconProps = {
	passedEvent?(): void;
	setEditData?: () => any;
	disabled?: boolean;
};

const EditIcon = ({ passedEvent = () => false, setEditData, disabled = false }: EditIconProps) => (
	<Button
		size="xs"
		variant="outline"
		disabled={disabled}
		onClick={() => {
			passedEvent();
			if (setEditData) {
				setEditData();
			}
		}}
		className="rounded-full text-green-900 border-green-900 hover:bg-green-900 hover:text-white"
	>
		<Pencil className="w-4 h-4" />
		<span className="sr-only">Edit</span>
	</Button>
);

export default EditIcon;
